import Vue from 'vue'
import IBAN from 'iban'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, numeric, max } from 'vee-validate/dist/rules'
import { imageFromFile } from '@/lib/imageHelper'
import { i18n } from '@/plugins/i18n'

const EMAIL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

extend('required', {
  ...required,
  message: () => i18n.t('forms.validation.required')
})

extend('email', {
  validate: value => EMAIL.test(value),
  message: () => i18n.t('forms.validation.email')
})

extend('numeric', {
  ...numeric,
  message: () => i18n.t('forms.validation.numeric')
})

extend('productAmount', {
  validate: value => value >= 1 && value <= 20,
  message: () => i18n.t('forms.validation.productAmount')
})

extend('percent', {
  validate: value => value >= 0 && value <= 100,
  message: () => i18n.t('forms.validation.percent')
})

extend('decimal', {
  validate: value => value.match(/^[0-9]+(,[0-9]{1,2})?$/) && parseFloat(value.replace(',', '.')) < 100,
  message: () => i18n.t('forms.validation.decimal')
})

extend('slug', {
  validate: value => value.match(/^[a-z0-9](-?[a-z0-9])*$/),
  message: () => i18n.t('forms.validation.slug')
})

extend('matchesValue', {
  params: ['expected'],
  validate: (value, { expected }) => value === expected,
  message: () => i18n.t('forms.validation.matchesValue')
})

extend('checked', {
  validate: value => value === true,
  message: () => i18n.t('forms.validation.checked')
})

extend('bleed', {
  validate: value => value.match(/^\d{1,2},\d{1,2},\d{1,2},\d{1,2}$/),
  message: () => i18n.t('forms.validation.bleed')
})

extend('gtm', {
  validate: value => value.match(/^GTM-[A-Z0-9]{1,8}$/),
  message: () => i18n.t('forms.validation.gtm')
})

extend('phone', {
  validate: value => value.match(/^\+?\d+$/),
  message: () => i18n.t('forms.validation.phone')
})

extend('hexcolor', {
  validate: value => value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i),
  message: () => i18n.t('forms.validation.hexcolor')
})

extend('protocol', {
  validate: value => value.match(/^https?:\/\//),
  message: () => i18n.t('forms.validation.protocol')
})

extend('iban', {
  validate: value => IBAN.isValid(value),
  message: () => i18n.t('forms.validation.iban')
})

extend('bic', {
  validate: value => value.match(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/),
  message: () => i18n.t('forms.validation.bic')
})

extend('maxLength', {
  ...max,
  message: () => i18n.t('forms.validation.maxLength')
})

extend('minImageSize', {
  validate: async (value, { minWidth, minHeight }) => {
    const image = await imageFromFile(value.file)
    return image.width >= parseInt(minWidth) && image.height >= parseInt(minHeight)
  },
  params: ['minWidth', 'minHeight'],
  message: (_field, params) => i18n.t('forms.validation.minImageSize', params)
})

extend('maxImageSize', {
  validate: async (value, { maxWidth, maxHeight }) => {
    const image = await imageFromFile(value.file)
    return image.width < parseInt(maxWidth) && image.height < parseInt(maxHeight)
  },
  params: ['maxWidth', 'maxHeight'],
  message: (_field, params) => i18n.t('forms.validation.maxImageSize', params)
})

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
